export default __webpack_public_path__ + "static/media/50d.12580af4.svg";